module.exports = __webpack_public_path__ + "static/media/restaurant.fb228d1c.jpg";